import XAPPService from 'app/Core/services/XAPPService';
export const GET_CHAVES = '{CHAVE APP] GET CHAVES';
export const OPEN_CHAVE_DIALOG = '{CHAVE APP] OPEN CHAVE DIALOG';
export const ADD_CHAVE = '{CHAVE APP] ADD CHAVE';
export const CHAVE_WARNING = '{CHAVE APP] CHAVE WARNING';
export const CHAVE_INFO = '{CHAVE APP] CHAVE INFO';
export const CHAVE_ERROR = '{CHAVE APP] CHAVE ERROR';

const ListState = [
    'tipo',
    'idchave',
    'destinatario',
    'destinatariodados',
    'remetente',
    'remetentedados',
    'codigo',
    'status',
    'formulario',
    'descricao',
    'validade',
    'validadedescricao',
    'statusregistro',
    'statusregistrodescricao'
];

export function list(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Chaves", AActions, "spvwchave", ListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_CHAVES,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: CHAVE_ERROR,
                    payload: error
                });
            });
    };
}

export function openDialog(_AValue = null) {
    return {
        type: OPEN_CHAVE_DIALOG,
        payload: _AValue
    }
}

export function save(_AValue, _AParams, _AAction) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "chave", _AAction, _AValue, "", AConditionsAND, AConditionsOR, 1);

        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: CHAVE_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, { AND: [{ Campo: "tipo", Operador: "=", Valor: _AValue.tipo }] })))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: CHAVE_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, { AND: [{ Campo: "tipo", Operador: "=", Valor: _AValue.tipo }] })))
                }
            }

            ).catch(error => {
                return dispatch({
                    type: CHAVE_ERROR,
                    payload: error
                });
            });
    };
}
